<template>

  <div>
    <div
      class="dropdown">
      <button
        :class="{'box-loading': loading}"
        class="btn btn-dark btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        <ConsentBullet
          :gdpr="candidate.gdpr"
          :legend="true" />
        </button>
      <div
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton">
        <button
          class="dropdown-item"
          :disabled="!candidate.email"
          @click="requestConsent">{{ $t('Request consent') }}</button>
      </div>
    </div>
  </div>

</template>

<script>
import ConsentBullet from '@/components/Parts/ConsentBullet'

export default {
  name: 'CandidateConsent',
  components: {
    ConsentBullet
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  created () {
  },
  methods: {
    requestConsent () {
      this.loading = true
      this.$store
      .dispatch('requestConsent', {
        candidate_id: this.candidate._id
      })
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateConsent.vue